<template>
    <div class="relative w-full">
        <textarea v-bind="$attrs" :value="inputValue" :placeholder="placeholder"
            class="w-full min-h-24 rounded-[var(--radius-md)] border bg-card px-3.5 py-2.5 text-[15px] text-foreground placeholder:text-muted-foreground outline-none transition-shadow focus:ring-2 focus:ring-offset-0 resize-none"
            :class="ringClass" @input="inputValue = ($event.target as HTMLTextAreaElement).value" @blur="handleBlur" />

        <ErrorMessage v-if="name" :name="name" />
    </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import { computed } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  name?: string
  modelValue?: string
  invalid?: boolean
  valid?: boolean
  placeholder?: string
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const { value: fieldValue, handleBlur } = useField<string>(() => props.name || '', undefined, {
  initialValue: props.modelValue || '',
  syncVModel: true,
})

const inputValue = computed({
  get: () => (props.name ? fieldValue.value : props.modelValue || ''),
  set: (value: string) => {
    if (props.name) {
      fieldValue.value = value
    }

    emit('update:modelValue', value)
  },
})

const ringClass = computed(() => {
  if (props.invalid) return 'border-[var(--danger)] focus:ring-[var(--danger)]'
  if (props.valid) return 'border-[var(--success)] focus:ring-[var(--success)]'
  return 'border-border focus:ring-primary'
})
</script>